export default __webpack_public_path__ + "static/MoblieAD-aefece4527fadb3677da9266048055cd.mp4";